import React, { useCallback } from 'react';
import LikeButton from '../../components/LikeButton/LikeButton';
import { useErrorReport } from '../../contexts/ErrorReportContext';
import { deleteEventDayReminder, upsertEventDayReminder } from './services/eventDayReminders';

/** Event save control. Schedules or cancels the day-of reminder after a successful like. */
export default function EventLikeButton({ onGiveawayLike, ...props }) {
  const { reportError } = useErrorReport();

  const onEventLiked = useCallback(async ({ uid, event, liked }) => {
    try {
      if (liked) await upsertEventDayReminder(uid, event);
      else await deleteEventDayReminder(uid, event?.id);
    } catch (err) {
      reportError(err, {
        pageLabel: 'Events',
        source: 'event-day-reminder',
        userMessage: 'Saved. Could not schedule the day-of reminder.',
      });
    }
    if (typeof onGiveawayLike === 'function') onGiveawayLike({ event, liked });
  }, [onGiveawayLike, reportError]);

  return <LikeButton {...props} onEventLiked={onEventLiked} />;
}
